var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import ContinueDraftPopup from './ContinueDraftPopup';
import { t } from '../core/utils/translation-helper';
import { createCartItem, fetchDraftItems } from '../modules/Cart/store/actions';
import { localizeUrl } from '../core/helpers/url-helper';
var mapDispatchToProps = {
    createCartItem: createCartItem,
    fetchDraftItems: fetchDraftItems,
};
var connector = connect(function () { return ({}); }, mapDispatchToProps);
var CreateCartItem = /** @class */ (function (_super) {
    __extends(CreateCartItem, _super);
    function CreateCartItem() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isPopupVisible: false,
        };
        return _this;
    }
    CreateCartItem.prototype.render = function () {
        var _this = this;
        return (React.createElement(React.Fragment, null,
            this.renderPopup(),
            React.createElement("div", { onClick: function () { return _this.createCartItem(); } }, this.props.children)));
    };
    CreateCartItem.prototype.renderPopup = function () {
        var _this = this;
        var _a;
        if (!this.state.isPopupVisible) {
            return null;
        }
        return (React.createElement(ContinueDraftPopup, { productName: (_a = t('name', this.props.item.translations)) !== null && _a !== void 0 ? _a : '', handleClose: function () { return _this.createCartItem(true); }, handleContinue: function () { return _this.props.history.push(localizeUrl('/drafts')); } }));
    };
    CreateCartItem.prototype.createCartItem = function (ignoreDrafts) {
        var _a;
        if (ignoreDrafts === void 0) { ignoreDrafts = false; }
        return __awaiter(this, void 0, void 0, function () {
            var draftsResponse, sameProducts, response, err_1;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 5, , 6]);
                        if (!!ignoreDrafts) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.props.fetchDraftItems()];
                    case 1:
                        draftsResponse = _b.sent();
                        if (draftsResponse) {
                            sameProducts = draftsResponse.find(function (item) { return item.product_id === _this.props.item.id; });
                            if (sameProducts) {
                                this.setState({ isPopupVisible: true });
                                return [2 /*return*/];
                            }
                        }
                        _b.label = 2;
                    case 2: return [4 /*yield*/, this.props.createCartItem(this.props.item.id, (_a = this.props.variant) === null || _a === void 0 ? void 0 : _a.id)];
                    case 3:
                        response = _b.sent();
                        if (!response) {
                            throw new Error('Invalid response on create cart item');
                        }
                        // redirect user to the cart items edit page
                        return [4 /*yield*/, this.props.history.push(localizeUrl("/cart-items/" + response.id))];
                    case 4:
                        // redirect user to the cart items edit page
                        _b.sent();
                        return [3 /*break*/, 6];
                    case 5:
                        err_1 = _b.sent();
                        return [3 /*break*/, 6];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    return CreateCartItem;
}(React.Component));
export default connector(withRouter(CreateCartItem));
